import { t } from '../../../../locale';
import { FlowInterface } from '../flow-interface';
import { generateBuyLink, generatePlanCategory } from '../../helper/utils';
import { planTypes } from '../../constant';

export default class AddTrial extends FlowInterface {
  getCurrentParams() {
    return {
      type: this.flowType,
      plan: this.basePlan,
      subPlan: 'newsubs',
      from: generatePlanCategory(planTypes.EVENT_SAAS_CORE, this.capacity),
      period: this.period,
      campaign_code: this.campaignCode,
      trial_code: this.trialCode,
    }
  }

  getLink() {
    return generateBuyLink(this.getCurrentParams());
  }

  getOptions() {
    return {
      disabled: !this.productEntryData?.currentUserHasPermission,
      buttonTitle: t('billing.product.entry_free_trial.buy'),
    };
  }
}
